module.exports = __webpack_public_path__ + "img/welcomes-text.3427a85b.png";